/* tslint:disable */
/* eslint-disable */
/**
 * Tardek API Endpoints
 * This Is a documentation for T1 Tardek API Endpoints. <br />
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: info@bitweb.ee
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 *
 * @export
 * @interface CreateDocumentRequestV3
 */
export interface CreateDocumentRequestV3 {
    /**
     * Internal type of the document
     * @type {string}
     * @memberof CreateDocumentRequestV3
     */
    'type': CreateDocumentRequestV3TypeEnum;
    /**
     * Document Reference Number
     * @type {string}
     * @memberof CreateDocumentRequestV3
     */
    'referenceNumber'?: string;
    /**
     * Document Transport Document Reference Number
     * @type {string}
     * @memberof CreateDocumentRequestV3
     */
    'transportDocumentReferenceNumber'?: string;
    /**
     * Document Complement of information
     * @type {string}
     * @memberof CreateDocumentRequestV3
     */
    'complementOfInformation'?: string;
    /**
     * Document line number
     * @type {string}
     * @memberof CreateDocumentRequestV3
     */
    'documentLineItemNumber'?: string;
    /**
     * Document Type
     * @type {string}
     * @memberof CreateDocumentRequestV3
     */
    'documentType': string;
    /**
     * Consignment Item ID
     * @type {number}
     * @memberof CreateDocumentRequestV3
     */
    'consignmentItemId'?: number | null;
    /**
     * Consignment ID
     * @type {number}
     * @memberof CreateDocumentRequestV3
     */
    'consignmentId'?: number | null;
    /**
     * House consignment ID
     * @type {number}
     * @memberof CreateDocumentRequestV3
     */
    'houseConsignmentId'?: number | null;
    /**
     * Transit Operation ID
     * @type {number}
     * @memberof CreateDocumentRequestV3
     */
    'transitOperationId': number;
    /**
     * Document Sequence Number
     * @type {number}
     * @memberof CreateDocumentRequestV3
     */
    'sequenceNumber': number;
    /**
     * Document Previous Procedure Type
     * @type {string}
     * @memberof CreateDocumentRequestV3
     */
    'procedureType'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateDocumentRequestV3TypeEnum {
  PREVIOUS = 'PREVIOUS',
  SUPPORTING = 'SUPPORTING',
  TRANSPORT = 'TRANSPORT',
  NOTE = 'NOTE',
  GLOBAL = 'GLOBAL'
}


